const getters = {
  isContextSupporter: state => state.currentContextType === 'supporter',
}

export default getters
